// extracted by mini-css-extract-plugin
module.exports = {"Lds":"AnimationLoader_Lds__2GTiz","LdsSpinner":"AnimationLoader_LdsSpinner__34toN","LdsSpinnerII":"AnimationLoader_LdsSpinnerII__x0aWh"};